import * as Types from '../../__generated_types__/types.generated';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type BingoGameSnapshotSubscriptionVariables = Types.Exact<{
  tenantId: Types.Scalars['String']['input'];
}>;


export type BingoGameSnapshotSubscription = { __typename?: 'Subscription', bingoGameSnapshot?: { __typename?: 'BingoGameSnapshot', tenantId?: string | null, gameId?: string | null, gameName?: string | null, currencyCode?: string | null, gameStartUtc?: any | null, gameStartEpoch?: any | null, jackpotAmount?: string | null, simplePrizePotAmount?: string | null, playersInGame?: number | null, isUpcoming?: boolean | null, mediatorId?: string | null, cardCost?: string | null } | null };


export const BingoGameSnapshotDocument = gql`
    subscription BingoGameSnapshot($tenantId: String!) {
  bingoGameSnapshot(tenantId: $tenantId) {
    tenantId
    gameId
    gameName
    currencyCode
    gameStartUtc
    gameStartEpoch
    jackpotAmount
    simplePrizePotAmount
    playersInGame
    isUpcoming
    mediatorId
    cardCost
  }
}
    `;

/**
 * __useBingoGameSnapshotSubscription__
 *
 * To run a query within a React component, call `useBingoGameSnapshotSubscription` and pass it any options that fit your needs.
 * When your component renders, `useBingoGameSnapshotSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBingoGameSnapshotSubscription({
 *   variables: {
 *      tenantId: // value for 'tenantId'
 *   },
 * });
 */
export function useBingoGameSnapshotSubscription(baseOptions: Apollo.SubscriptionHookOptions<BingoGameSnapshotSubscription, BingoGameSnapshotSubscriptionVariables> & ({ variables: BingoGameSnapshotSubscriptionVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<BingoGameSnapshotSubscription, BingoGameSnapshotSubscriptionVariables>(BingoGameSnapshotDocument, options);
      }
export type BingoGameSnapshotSubscriptionHookResult = ReturnType<typeof useBingoGameSnapshotSubscription>;
export type BingoGameSnapshotSubscriptionResult = Apollo.SubscriptionResult<BingoGameSnapshotSubscription>;